import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById('root')
console.log('ROOT ELEMENT:', rootElement)
console.log('VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL)

if (!rootElement) {
  console.error('ROOT ELEMENT NOT FOUND!')
  document.body.innerHTML = '<h1 style="color: red;">ERROR: Root element not found</h1>'
} else {
  console.log('Mounting React app...')
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </React.StrictMode>
    )
    console.log('React app mounted successfully')
  } catch (error) {
    console.error('Error mounting React app:', error)
    document.body.innerHTML = '<h1 style="color: red;">ERROR: ' + error + '</h1>'
  }
}
